(() => {
  'use strict';

  /* =========================================================
     SELECTORS
  ========================================================== */
  const BUNDLE_SELECTOR = '[data-tp-bundle]';
  const OPTION_SELECTOR = '[data-tp-bundle-option]';
  const RADIO_SELECTOR = '[data-tp-bundle-radio]';
  const VARIANT_SELECTOR = '[data-tp-variant-select]';
  const ORDER_SELECTOR = '[data-tp-bundle-order]';
  const CARD_PAY_SELECTOR = '[data-tp-iyzico-pay]';

  /* =========================================================
     STATE
  ========================================================== */
  const state = {
    quantity: 1,
    package: '1 ADET',
    price: 1499,
    compare: 1499,
    variants: [],
    bundleGroup: null
  };

  let lastEasySellSyncedQuantity = null;

  /* =========================================================
     BUNDLE HELPERS
  ========================================================== */
  function getBundles() {
    return Array.from(
      document.querySelectorAll(
        BUNDLE_SELECTOR
      )
    );
  }

  function getOptions(bundle) {
    if (!bundle) return [];

    return Array.from(
      bundle.querySelectorAll(
        OPTION_SELECTOR
      )
    );
  }

  function getActiveOption(bundle) {
    if (!bundle) return null;

    return bundle.querySelector(
      `${OPTION_SELECTOR}.is-active`
    ) || null;
  }

  function createBundleGroup() {
    return `tp-mirumi-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  }

  function ensureBundleGroup() {
    if (!state.bundleGroup) {
      state.bundleGroup =
        createBundleGroup();
    }

    return state.bundleGroup;
  }

  /* =========================================================
     VARIANT OKU
  ========================================================== */
  function readVariants(option) {
    if (!option) return [];

    return Array.from(
      option.querySelectorAll(
        VARIANT_SELECTOR
      )
    )
      .map((select) => {
        const selected =
          select.options[
            select.selectedIndex
          ];

        return {
          index: Number(
            select.dataset.itemIndex || 1
          ),

          id: String(
            select.value || ''
          ).trim(),

          color:
            selected?.dataset.color ||
            selected?.textContent?.trim() ||
            ''
        };
      })
      .filter(
        (item) => item.id
      )
      .sort(
        (a, b) =>
          Number(a.index || 0) -
          Number(b.index || 0)
      );
  }

  function buildColorSummary() {
    return state.variants
      .filter(
        (item) =>
          item &&
          item.id
      )
      .sort(
        (a, b) =>
          Number(a.index || 0) -
          Number(b.index || 0)
      )
      .map(
        (item) =>
          `${item.index}. Ürün: ${item.color}`
      )
      .join(' | ');
  }

  function getProductForm(bundle) {
    if (bundle) {
      const section =
        bundle.closest(
          'section, product-information, product-form-component'
        );

      const localForm =
        section?.querySelector(
          'form[action*="/cart/add"]'
        );

      if (localForm) {
        return localForm;
      }

      const parentForm =
        bundle.parentElement?.querySelector(
          'form[action*="/cart/add"]'
        );

      if (parentForm) {
        return parentForm;
      }
    }

    return (
      document.querySelector(
        'form[action*="/cart/add"]'
      ) ||
      document.querySelector(
        'form.product-form'
      ) ||
      document.querySelector(
        'product-form form'
      )
    );
  }

  function syncNativeProductVariant(
    variantId,
    bundle
  ) {
    const id = String(
      variantId || ''
    ).trim();

    if (!id) return;

    const escapedId =
      typeof CSS !== 'undefined' &&
      typeof CSS.escape === 'function'
        ? CSS.escape(id)
        : id.replace(
            /"/g,
            '\\"'
          );

    const root =
      bundle?.closest(
        'section, product-information, product-form-component'
      ) || document;

    const nativeInput =
      root.querySelector(
        `[data-variant-id="${escapedId}"]`
      ) ||
      document.querySelector(
        `[data-variant-id="${escapedId}"]`
      );

    if (
      nativeInput &&
      nativeInput instanceof
        HTMLInputElement &&
      !nativeInput.checked
    ) {
      nativeInput.click();

      nativeInput.dispatchEvent(
        new Event(
          'input',
          {
            bubbles: true
          }
        )
      );

      nativeInput.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );
    }
  }

  function publishEasySellAdditionalDetails() {
    const colorSummary =
      buildColorSummary();

    if (!colorSummary) {
      return;
    }

    window.ES_ADDITIONAL_DETAILS = {
      ...(window.ES_ADDITIONAL_DETAILS || {}),

      tp_mirumi_colors: {
        title: 'Paket Renkleri',
        value: colorSummary
      }
    };
  }

  /* =========================================================
     SHOPIFY AJAX SEPET GÜNCELLEME
     EasySell mevcut sistem için kullanılır.
  ========================================================== */
  async function syncShopifyCartAjax(
    items
  ) {
    try {
      // 1. Sepeti tamamen temizle
      await fetch(
        '/cart/clear.js',
        {
          method: 'POST'
        }
      );

      // 2. Seçilen paket ürünlerini sepete ekle
      const response =
        await fetch(
          '/cart/add.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json'
            },

            body: JSON.stringify({
              items: items
            })
          }
        );

      const cartData =
        await response.json();

      // 3. Tema sepet olaylarını tetikle
      document.dispatchEvent(
        new CustomEvent(
          'cart:updated',
          {
            detail: {
              cart: cartData
            }
          }
        )
      );

      document.dispatchEvent(
        new CustomEvent(
          'cart:refresh',
          {
            detail: {
              cart: cartData
            }
          }
        )
      );

      return cartData;

    } catch (err) {
      console.error(
        '[TinyPuffy] Sepet senkronizasyon hatası:',
        err
      );

      return null;
    }
  }

  function prepareEasySellForm(
    bundle,
    items
  ) {
    const form =
      getProductForm(bundle);

    if (form) {
      window.ES_CLOSEST_FORM =
        form;
    }

    return form;
  }

  function buildEasySellItems() {
    const variants =
      state.variants
        .filter(
          (item) =>
            item &&
            item.id
        )
        .sort(
          (a, b) =>
            Number(a.index || 0) -
            Number(b.index || 0)
        );

    if (!variants.length) {
      return [];
    }

    const group =
      ensureBundleGroup();

    const expectedQuantity =
      variants.length;

    return variants.map(
      (item) => ({
        id: Number(
          item.id
        ),

        quantity: 1,

        properties: {
          Paket:
            state.package,

          'Ürün Rengi':
            item.color,

          pmpr_cart_item:
            group,

          [`${item.index}. Ürün Rengi`]:
            item.color,

          '_Paket Sırası':
            `${item.index}/${expectedQuantity}`
        }
      })
    );
  }

  function publishEasySellPayload(
    items
  ) {
    window.pmpr_cart_item =
      items;

    window.tinyPuffyEasySellPayload =
      items;

    publishEasySellAdditionalDetails();
  }

  function publishEasySellBundle(
    bundle
  ) {
    const items =
      buildEasySellItems();

    if (!items.length) {
      return [];
    }

    publishEasySellPayload(
      items
    );

    prepareEasySellForm(
      bundle,
      items
    );

    window.tinyPuffyBundle = {
      quantity:
        state.quantity,

      package:
        state.package,

      price:
        state.price,

      compare:
        state.compare,

      variants: [
        ...state.variants
      ],

      items,

      colorSummary:
        buildColorSummary(),

      group:
        ensureBundleGroup()
    };

    return items;
  }

  function updateState(
    bundle,
    option
  ) {
    if (
      !bundle ||
      !option
    ) {
      return;
    }

    state.quantity =
      Number(
        option.dataset.quantity ||
        1
      );

    state.package =
      option.dataset.package ||
      '';

    state.price =
      Number(
        option.dataset.price ||
        0
      );

    state.compare =
      Number(
        option.dataset.compare ||
        0
      );

    state.variants =
      readVariants(option);

    state.bundleGroup =
      createBundleGroup();

    const primaryVariant =
      state.variants.find(
        (item) => item.id
      );

    if (primaryVariant) {
      syncNativeProductVariant(
        primaryVariant.id,
        bundle
      );
    }

    bundle.dataset.selectedQuantity =
      String(
        state.quantity
      );

    bundle.dataset.selectedPackage =
      state.package;

    bundle.dataset.selectedPrice =
      String(
        state.price
      );

    bundle.dataset.selectedCompare =
      String(
        state.compare
      );

    bundle.dataset.selectedVariants =
      JSON.stringify(
        state.variants
      );

    publishEasySellAdditionalDetails();

    lastEasySellSyncedQuantity =
      null;

    bundle.dispatchEvent(
      new CustomEvent(
        'tp:bundle-change',
        {
          bubbles: true,

          detail: {
            ...state,

            variants: [
              ...state.variants
            ]
          }
        }
      )
    );
  }

  function activateOption(
    bundle,
    option
  ) {
    const options =
      getOptions(bundle);

    options.forEach(
      (item) => {
        const radio =
          item.querySelector(
            RADIO_SELECTOR
          );

        const active =
          item === option;

        item.classList.toggle(
          'is-active',
          active
        );

        if (radio) {
          radio.checked =
            active;
        }
      }
    );

    updateState(
      bundle,
      option
    );

    publishEasySellBundle(
      bundle
    );
  }

  function syncEasySellPopupPackage() {
    const offersContainer =
      document.querySelector(
        '.es-quantity-offers'
      );

    if (!offersContainer) {
      return;
    }

    const offers =
      Array.from(
        offersContainer.querySelectorAll(
          '.es-qo-container'
        )
      );

    if (!offers.length) {
      return;
    }

    const quantity =
      Number(
        state.quantity || 1
      );

    const targetIndex =
      Math.max(
        0,
        Math.min(
          quantity - 1,
          offers.length - 1
        )
      );

    const targetOffer =
      offers[targetIndex];

    if (
      !targetOffer ||
      lastEasySellSyncedQuantity ===
        quantity
    ) {
      return;
    }

    const radio =
      targetOffer.querySelector(
        'input[type="radio"], input[type="checkbox"]'
      );

    if (
      radio &&
      !radio.checked
    ) {
      radio.click();

    } else if (!radio) {
      targetOffer.click();
    }

    if (radio) {
      radio.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );
    }

    lastEasySellSyncedQuantity =
      quantity;

    publishEasySellAdditionalDetails();
  }

  function bindVariantSelect(
    bundle,
    select
  ) {
    if (
      select.dataset.tpVariantBound ===
      'true'
    ) {
      return;
    }

    select.dataset.tpVariantBound =
      'true';

    select.addEventListener(
      'change',
      () => {
        const active =
          getActiveOption(bundle);

        if (!active) {
          return;
        }

        state.variants =
          readVariants(active);

        state.quantity =
          Number(
            active.dataset.quantity ||
            state.variants.length ||
            1
          );

        state.package =
          active.dataset.package ||
          '';

        state.price =
          Number(
            active.dataset.price ||
            0
          );

        state.compare =
          Number(
            active.dataset.compare ||
            0
          );

        state.bundleGroup =
          createBundleGroup();

        const first =
          state.variants.find(
            (item) =>
              item.id
          );

        if (first) {
          syncNativeProductVariant(
            first.id,
            bundle
          );
        }

        bundle.dataset.selectedVariants =
          JSON.stringify(
            state.variants
          );

        publishEasySellBundle(
          bundle
        );
      }
    );
  }

  /* =========================================================
     EASYESELL FORMUNU SEPETLE BİRLİKTE AÇMA
  ========================================================== */
  async function openEasySellDirectly(
    bundle,
    button
  ) {
    const active =
      getActiveOption(bundle);

    if (!active) {
      return;
    }

    const latestVariants =
      readVariants(active);

    if (!latestVariants.length) {
      return;
    }

    state.quantity =
      Number(
        active.dataset.quantity ||
        latestVariants.length ||
        1
      );

    state.package =
      active.dataset.package ||
      `${state.quantity} Adet`;

    state.price =
      Number(
        active.dataset.price ||
        0
      );

    state.compare =
      Number(
        active.dataset.compare ||
        0
      );

    state.variants =
      latestVariants;

    state.bundleGroup =
      createBundleGroup();

    const items =
      buildEasySellItems();

    if (!items.length) {
      return;
    }

    // 1. Önce sepeti arka planda güncelle
    await syncShopifyCartAjax(
      items
    );

    // 2. EasySell verilerini hazırla
    publishEasySellPayload(
      items
    );

    prepareEasySellForm(
      bundle,
      items
    );

    // 3. EasySell form tetikleyicisini çalıştır
    if (
      typeof window.openTysloForm ===
      'function'
    ) {
      window.openTysloForm();
      return;
    }

    const appButton =
      document.querySelector(
        '.es-popup-button-product, #es-popup-button, [data-es-popup]'
      );

    if (
      appButton &&
      appButton !== button
    ) {
      appButton.click();
    }
  }

  function bindOrderButton(
    bundle
  ) {
    const button =
      bundle.querySelector(
        ORDER_SELECTOR
      );

    if (
      !button ||
      button.dataset.tpOrderBound ===
        'true'
    ) {
      return;
    }

    button.dataset.tpOrderBound =
      'true';

    button.addEventListener(
      'click',
      async (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        try {
          await openEasySellDirectly(
            bundle,
            button
          );

        } catch (error) {
          console.error(
            '[TinyPuffy] EasySell açılış hatası:',
            error
          );
        }
      },
      true
    );
  }

  /* =========================================================
     KARTLA ÖDE / İYZİCO CHECKOUT
     Mevcut EasySell butonuna dokunmaz.
  ========================================================== */

  function ensureCardPayButton(
    bundle
  ) {
    if (!bundle) {
      return null;
    }

    const existing =
      bundle.querySelector(
        CARD_PAY_SELECTOR
      );

    if (existing) {
      return existing;
    }

    const orderButton =
      bundle.querySelector(
        ORDER_SELECTOR
      );

    if (!orderButton) {
      return null;
    }

    /* ---------------------------------------------------------
       TURUNCU KARTLA ÖDE BUTON STİLLERİ
    --------------------------------------------------------- */

    if (
      !document.getElementById(
        'tp-iyzico-card-pay-styles'
      )
    ) {
      const style =
        document.createElement(
          'style'
        );

      style.id =
        'tp-iyzico-card-pay-styles';

      style.textContent = `
        .tp-bundle__card-pay-wrap {
          display: block;
          width: 100%;
          margin: 8px 0 0;
          padding: 0;
        }

        .tp-bundle__card-pay {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          width: 100%;
          min-height: 56px;

          margin: 0;
          padding: 10px 18px;

          gap: 3px;

          border: 0;
          border-radius: 16px;

          background: linear-gradient(
            135deg,
            #ff9f43 0%,
            #ff7a18 100%
          );

          color: #fff;

          cursor: pointer;

          box-shadow:
            0 8px 22px rgba(
              255,
              122,
              24,
              .24
            );

          transition:
            transform .2s ease,
            box-shadow .2s ease,
            filter .2s ease;
        }

        .tp-bundle__card-pay:hover {
          transform: translateY(-2px);

          filter: brightness(1.04);

          box-shadow:
            0 12px 28px rgba(
              255,
              122,
              24,
              .32
            );
        }

        .tp-bundle__card-pay:active {
          transform: translateY(0);
        }

        .tp-bundle__card-pay:disabled {
          opacity: .65;
          cursor: wait;
          transform: none;
        }

        .tp-bundle__card-pay-title {
          display: block;

          font-size: 13px;
          line-height: 1.2;
          font-weight: 900;

          letter-spacing: .03em;
        }

        .tp-bundle__card-pay-subtitle {
          display: block;

          font-size: 8px;
          line-height: 1.2;
          font-weight: 700;

          opacity: .95;
        }

        @media screen and (max-width: 749px) {

          .tp-bundle__card-pay-wrap {
            margin-top: 8px;
          }

          .tp-bundle__card-pay {
            min-height: 54px;
            border-radius: 15px;
          }

          .tp-bundle__card-pay-title {
            font-size: 12px;
          }

          .tp-bundle__card-pay-subtitle {
            font-size: 7.5px;
          }
        }
      `;

      document.head.appendChild(
        style
      );
    }

    /* ---------------------------------------------------------
       BUTONU OLUŞTUR
    --------------------------------------------------------- */

    const wrapper =
      document.createElement(
        'div'
      );

    wrapper.className =
      'tp-bundle__card-pay-wrap';

    const button =
      document.createElement(
        'button'
      );

    button.type =
      'button';

    button.setAttribute(
      'data-tp-iyzico-pay',
      'true'
    );

    button.className =
      'tp-bundle__card-pay';

    button.innerHTML = `
      <span class="tp-bundle__card-pay-title">
        KREDİ KARTIYLA ÖDE
      </span>

      <small class="tp-bundle__card-pay-subtitle">
        iyzico ile güvenli ödeme
      </small>
    `;

    wrapper.appendChild(
      button
    );

    /*
     * Mevcut "ŞİMDİ SİPARİŞ VER"
     * butonunun hemen altına eklenir.
     */
    orderButton.parentNode.insertBefore(
      wrapper,
      orderButton.nextSibling
    );

    return button;
  }

  /* =========================================================
     CHECKOUT ITEMS
  ========================================================== */

  function buildCheckoutItems() {
    return state.variants
      .filter(
        (item) =>
          item &&
          item.id
      )
      .sort(
        (a, b) =>
          Number(a.index || 0) -
          Number(b.index || 0)
      )
      .map(
        (item) => ({
          id: Number(
            item.id
          ),

          quantity: 1,

          properties: {
            Paket:
              state.package,

            'Ürün Rengi':
              item.color,

            [`${item.index}. Ürün Rengi`]:
              item.color,

            '_Paket Sırası':
              `${item.index}/${state.variants.length}`
          }
        })
      );
  }

  /* =========================================================
     KARTLA ÖDE CHECKOUT
  ========================================================== */

  async function openCardPaymentCheckout(
    bundle,
    button
  ) {
    const active =
      getActiveOption(bundle);

    if (!active) {
      return;
    }

    const latestVariants =
      readVariants(active);

    if (!latestVariants.length) {
      console.error(
        '[TinyPuffy] Kartla ödeme için seçili varyant bulunamadı.'
      );

      return;
    }

    state.quantity =
      Number(
        active.dataset.quantity ||
        latestVariants.length ||
        1
      );

    state.package =
      active.dataset.package ||
      `${state.quantity} Adet`;

    state.price =
      Number(
        active.dataset.price ||
        0
      );

    state.compare =
      Number(
        active.dataset.compare ||
        0
      );

    state.variants =
      latestVariants;

    state.bundleGroup =
      createBundleGroup();

    const items =
      buildCheckoutItems();

    if (!items.length) {
      return;
    }

    const originalText =
      button.innerHTML;

    button.disabled =
      true;

    button.classList.add(
      'is-loading'
    );

    button.innerHTML = `
      <span class="tp-bundle__card-pay-title">
        ÖDEME SAYFASI AÇILIYOR...
      </span>

      <small class="tp-bundle__card-pay-subtitle">
        Lütfen bekleyin
      </small>
    `;

    try {
      /*
       * Seçilen paket + renkleri
       * Shopify sepetine ekle.
       */
      const cartData =
        await syncShopifyCartAjax(
          items
        );

      if (!cartData) {
        throw new Error(
          'Shopify sepeti oluşturulamadı.'
        );
      }

      /*
       * Son ödeme bilgisini global
       * olarak da sakla.
       */
      window.tinyPuffyCardPayment = {
        quantity:
          state.quantity,

        package:
          state.package,

        price:
          state.price,

        compare:
          state.compare,

        variants: [
          ...state.variants
        ],

        items
      };

      /*
       * Shopify checkout.
       *
       * Aktif iyzico ödeme sağlayıcısı
       * checkout ekranında kullanılacaktır.
       */
      window.location.href =
        '/checkout';

    } catch (error) {
      console.error(
        '[TinyPuffy] Kartla ödeme / checkout hatası:',
        error
      );

      button.disabled =
        false;

      button.classList.remove(
        'is-loading'
      );

      button.innerHTML =
        originalText;

      alert(
        'Ödeme sayfası açılamadı. Lütfen tekrar deneyin.'
      );
    }
  }

  /* =========================================================
     KARTLA ÖDE BUTONUNU BAĞLA
  ========================================================== */

  function bindCardPayButton(
    bundle
  ) {
    const button =
      ensureCardPayButton(
        bundle
      );

    if (
      !button ||
      button.dataset.tpCardPayBound ===
        'true'
    ) {
      return;
    }

    button.dataset.tpCardPayBound =
      'true';

    button.addEventListener(
      'click',
      async (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        try {
          await openCardPaymentCheckout(
            bundle,
            button
          );

        } catch (error) {
          console.error(
            '[TinyPuffy] Kartla ödeme hatası:',
            error
          );
        }
      },
      true
    );
  }

  /* =========================================================
     INIT
  ========================================================== */

  function initBundle(
    bundle
  ) {
    if (
      !bundle ||
      bundle.dataset.tpInitialized ===
        'true'
    ) {
      return;
    }

    bundle.dataset.tpInitialized =
      'true';

    const options =
      getOptions(bundle);

    if (!options.length) {
      return;
    }

    options.forEach(
      (option) => {
        const radio =
          option.querySelector(
            RADIO_SELECTOR
          );

        option.addEventListener(
          'click',
          (e) => {
            if (
              e.target.tagName ===
              'SELECT'
            ) {
              return;
            }

            activateOption(
              bundle,
              option
            );
          }
        );

        if (radio) {
          radio.addEventListener(
            'change',
            () =>
              activateOption(
                bundle,
                option
              )
          );
        }

        option
          .querySelectorAll(
            VARIANT_SELECTOR
          )
          .forEach(
            (select) => {
              bindVariantSelect(
                bundle,
                select
              );
            }
          );
      }
    );

    const checked =
      bundle.querySelector(
        `${RADIO_SELECTOR}:checked`
      );

    const initial =
      checked?.closest(
        OPTION_SELECTOR
      ) ||
      options[0];

    if (initial) {
      state.bundleGroup =
        createBundleGroup();

      activateOption(
        bundle,
        initial
      );
    }

    /*
     * Mevcut kapıda ödeme /
     * EasySell butonu.
     */
    bindOrderButton(
      bundle
    );

    /*
     * Yeni kredi kartı /
     * iyzico checkout butonu.
     */
    bindCardPayButton(
      bundle
    );
  }

  function initAll() {
    getBundles().forEach(
      (bundle) =>
        initBundle(
          bundle
        )
    );
  }

  function start() {
    initAll();

    const observer =
      new MutationObserver(
        () => {
          initAll();
          syncEasySellPopupPackage();
        }
      );

    if (document.body) {
      observer.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );
    }

    syncEasySellPopupPackage();
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }

})();